export const bytesToReadable = bytes => {
    if (bytes / Math.pow(1024, 2) >= 1) {
        return (bytes / Math.pow(1024, 2)).toFixed(2) + 'MB';
    } else if (bytes / 1024 >= 1) {
        return (bytes / 1024).toFixed(2) + 'KB';
    }
    return bytes + 'B';
};
